module.exports = __webpack_public_path__ + "img/floor_EG1.a87fcca8.svg";